import { Col, Row } from "reactstrap";
import { useKeycloak } from "@react-keycloak/web";
import { translate } from "react-switch-lang";
import hasRoles from "../../security/hasRoles";
import AgrisudLogo from "../../assets/images/logo/agrisud-logo.png";
import styles from "./landing-page-footer.module.scss";
import AgriterLogo from "../../assets/images/logo/logo_AGRITER-web-transparent.png";
import AgriterLogoEN from "../../assets/images/logo/logo_AGRITER-web-transparentEN.png";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useEffect } from "react";

const LandingPageFooter: React.FC<{ t: any }> = ({ t }) => {
  const keycloak = useKeycloak().keycloak;
  const hasRoleAdmin = hasRoles(["ROLE_ELEARNING_ADMIN"], keycloak);
  const currentLang = useSelector((state: RootState) => state.language.currentLang);
  useEffect(()=>{
  },[currentLang])

  return (
    <footer>
      <div className={hasRoleAdmin ? styles["admin-site-footer"] : styles["site-footer"]}>
        <Row>
          <Col md={12} className={styles["footer-icons-wrapper"]}>
            <a href={currentLang === "fr" ? "https://www.agrisud.org/web/" : "https://www.agrisud.org/web/en"} target="_blank" rel="noreferrer">
              <img width="130" src={AgrisudLogo} alt="agrisud-footer-logo" />
            </a>
            <div className={styles["footer-icons"]}>
              <a href="https://www.facebook.com/agrisudinternational" target="_blank" rel="noreferrer">
                <i className={`${styles["footer-icon"]} fa fa-facebook`}></i>
              </a>
              <a href="https://www.youtube.com/channel/UCh2gpZfUz0E6uiKsxMcMiog" target="_blank" rel="noreferrer">
                <i className={`${styles["footer-icon"]} fa fa-youtube-play`}></i>
              </a>
              <a href="https://twitter.com/Agrisud_ONG" target="_blank" rel="noreferrer">
                <i className={`${styles["footer-icon"]} fa fa-twitter`}></i>
              </a>
              <a href="https://www.linkedin.com/company/agrisud-international" target="_blank" rel="noreferrer">
                <i className={`${styles["footer-icon"]} fa fa-linkedin-in`}></i>
              </a>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className={styles["footer-agriter"]}>
              <p>
                {t("footer.agriter_text")}
                <a href={
                    currentLang === "fr"
                      ? "https://agrisud.int.norsys-afrique.ma/web/agriter-agriculture-durable-et-dynamiques-territoriales-dans-les-pays-du-sud"
                      : "https://www.agrisud.org/web/en/agriter-sustainable-agriculture-and-dynamics-territories-southern-countries"
                  } target="_blank" rel="noreferrer">
                  <span>
                    <img src={currentLang === 'fr' ? AgriterLogo : AgriterLogoEN} alt="" className={styles["agriter-image"]} />
                  </span>
                </a>
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className={styles["footer-coryright"]}>
              <span>{t("footer.copyright")}</span>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className={styles["footer-links"]}>
              <h6 className={styles["footer-link"]}>
                <a href={currentLang === "fr" ? "https://www.agrisud.org/web/mentions-legales" : "https://www.agrisud.org/web/en/legal-information"} target="_blank" rel="noreferrer">
                  {t("footer.legal_informarion")}
                </a>
              </h6>
              {window.outerWidth > 760 && <span>&ensp;&ensp;&ensp;|&ensp;&ensp;&ensp;</span>}
              <h6 className={styles["footer-link"]}>
                <a href={currentLang === "fr" ? "https://www.agrisud.org/web/donnees-personnelles" : "https://www.agrisud.org/web/en/personal-data"} target="_blank" rel="noreferrer">
                  {t("footer.personal_data")}
                </a>
              </h6>
              {window.outerWidth > 760 && <span>&ensp;&ensp;&ensp;|&ensp;&ensp;&ensp;</span>}
              <h6 className={styles["footer-link"]}>
                <a href={currentLang === "fr" ? "https://www.agrisud.org/web/cookies" : "https://www.agrisud.org/web/en/cookies"} target="_blank" rel="noreferrer">
                  Cookies
                </a>
              </h6>
              {window.outerWidth > 760 && <span>&ensp;&ensp;&ensp;|&ensp;&ensp;&ensp;</span>}
              <h6 className={styles["footer-link"]}>
                <a href="https://www.agrisud.org/web/sitemap" target="_blank" rel="noreferrer">
                  {t("footer.site_map")}
                </a>
              </h6>
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default translate(LandingPageFooter);
